module.exports = __webpack_public_path__ + "media/images/marker-7dee8d5ef14cb17fc9c20208bc0de6b4.png";